<div class="sub-page-root-home container-fluid mb-3 pt-5 text-start">
  <div class="text-center">
    <h4 [innerHtml]="'home-header' | transloco"></h4>
    <button class="mb-3" type="start" (click)="start()">Start</button>
  </div>

</div>
